import useSWR from "swr";

type MenuImages = {
  id: string;
  restaurant: string;
  menu_type: string;
  img: string;
}[]
export const useFetchDrinkMenuByRestaurantId = (restaurantId: string) => {
  const fetcherKey = restaurantId ? `menu/restaurants/${restaurantId}/drink/` : null;
  const { data: drinkMenuImages, error, isLoading } = useSWR<MenuImages>(fetcherKey)
  return { drinkMenuImages, isLoading, error };
};

